import { type VideoObject, type WithContext } from 'schema-dts'

import { type Pim3qsdnVideoV1 } from '@redteclab/api/clients/bully'

const SECONDS_IN_A_MINUTE = 60
const SECONDS_IN_AN_HOUR = 3600

const getIso8601DurationFromSeconds = (
  durationInSeconds: number,
): string | undefined => {
  if (durationInSeconds <= 0) {
    return undefined
  }

  const date = new Date(0)
  date.setSeconds(durationInSeconds)
  let duration = `${date.getUTCSeconds()}S`

  if (durationInSeconds >= SECONDS_IN_A_MINUTE) {
    duration = `${date.getUTCMinutes()}M${duration}`
  }

  if (durationInSeconds >= SECONDS_IN_AN_HOUR) {
    duration = `${date.getUTCHours()}H${duration}`
  }

  return `T${duration}`
}

export const getVideoSchema = (
  productName: string,
  video: Pim3qsdnVideoV1,
): WithContext<VideoObject> => ({
  '@context': 'https://schema.org',
  '@id': `https://shop-apotheke.com/#${productName}-${video.created}`,
  '@type': 'VideoObject',
  datePublished: video.created,
  description: video.description,
  duration: getIso8601DurationFromSeconds(video.duration_in_seconds),
  name: productName,
  thumbnailUrl: video.thumbnail,
  uploadDate: video.created,
})
